import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { NotificationService } from '@cutting/main/shared/services/notification.service';
import {
  CriticalNotificationDialogComponent,
  CuttingClientIdentification,
  DialogsService,
  IClientCuttingNotification,
  ICustomResponse,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { filter, finalize, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'cutting-quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuickPanelComponent implements OnDestroy {
  notifyConnection$: Observable<boolean>;
  notifications$: Observable<ICustomResponse<IClientCuttingNotification[]>>;
  markAsRead$: Observable<void>;
  unsubscribe$: Subject<void> = new Subject();
  markAsReadProcess = false;

  notifications: IClientCuttingNotification[] = [];

  /**
   * Constructor
   * @param notificationService
   * @param dialogsService
   */
  constructor(private notificationService: NotificationService, private dialogsService: DialogsService) {
    this.notifyConnection$ = this.notificationService.connected$.pipe(
      filter(connected => connected),
      tap(() => {
        this.notificationService.connection.on(
          this.notificationService.hasCommonNotifications,
          (notificationsCount: number, clientId: number) => {
            if (this.client.id === clientId) {
              this.makeRequest();
            }
          }
        );
      })
    );
  }

  makeRequest(): void {
    this.notifications$ = this.notificationService.getCommonNotifications().pipe(
      tap(res => {
        if (res.result) {
          this.notifications = res.result;
          this.showCriticalNotifications(res.result.filter(res => res.critical && !res.read));
        }

        if (res.error) {
          this.notifications = [];
        }
      })
    );
  }

  markAsRead(notificationIds: number[]): void {
    this.markAsReadProcess = true;
    this.markAsRead$ = this.notificationService
      .markAsRead(notificationIds)
      .pipe(tap(() => (this.markAsReadProcess = false)));
  }

  markAllAsRead(): void {
    this.markAsReadProcess = true;
    this.markAsRead$ = this.notificationService.markAllAsRead().pipe(finalize(() => (this.markAsReadProcess = false)));
  }

  get client(): CuttingClientIdentification {
    return LocalStorageManager.client;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }

  private showCriticalNotifications(criticalNotifications: IClientCuttingNotification[]): void {
    const notificationIds: number[] = [];

    _.each(criticalNotifications, item => {
      this.dialogsService
        .component(
          CriticalNotificationDialogComponent,
          {
            title: item.title,
            message: item.content,
          },
          400,
          { disableClose: true }
        )
        .pipe(
          tap(() => notificationIds.push(item.id)),
          finalize(() => {
            if (criticalNotifications.length === notificationIds.length) {
              this.markAsRead(notificationIds);
            }
          }),
          takeUntil(this.unsubscribe$)
        )
        .subscribe();
    });
  }
}
